module.exports = __webpack_public_path__ + "img/88_1.a59b87f9.png";